module.exports = __webpack_public_path__ + "static/hk-export-1c953099f17145bed9b73bff7370632f.png";